import { requisitarJson } from '../../../shared/api/http';

export interface GrupoCadastrado {
    id: string;
    nome: string | null;
    participantes: number;
}

export interface TurmaCadastrada {
    id: string;
    nome: string | null;
    ativa: boolean;
    grupos: GrupoCadastrado[];
}

export interface ParticipanteCadastrado {
    id: string;
    matricula: string;
    nome: string | null;
    grupo_id: string | null;
    lider: boolean;
    ativo: boolean;
}

/** O código de acesso só existe nesta resposta: o servidor guarda apenas o hash. */
export interface ParticipanteComCodigo extends ParticipanteCadastrado {
    codigo: string;
    sessoes_encerradas: number;
}

export interface NovoParticipante {
    matricula: string;
    nome: string;
    grupo_id: string;
    lider: boolean;
}

export type AlteracaoParticipante = Partial<Pick<ParticipanteCadastrado, 'nome' | 'grupo_id' | 'lider' | 'ativo'>>;

const BASE = '/api/v1/cadastro/turmas';
const turma = (turmaId: string) => `${BASE}/${encodeURIComponent(turmaId)}`;

function escrever<T>(caminho: string, metodo: 'POST' | 'PATCH', csrfToken: string, corpo?: unknown): Promise<T> {
    return requisitarJson<T>(caminho, {
        method: metodo,
        csrfToken,
        ...(corpo === undefined ? {} : { headers: { 'Content-Type': 'application/json' }, body: JSON.stringify(corpo) }),
    });
}

export function detalharTurma(turmaId: string): Promise<TurmaCadastrada> {
    return requisitarJson(turma(turmaId));
}

export function criarTurma(dados: { id: string; nome: string }, csrfToken: string): Promise<TurmaCadastrada> {
    return escrever(BASE, 'POST', csrfToken, dados);
}

export function criarGrupo(turmaId: string, dados: { id: string; nome: string }, csrfToken: string): Promise<GrupoCadastrado> {
    return escrever(`${turma(turmaId)}/grupos`, 'POST', csrfToken, dados);
}

export function criarParticipante(turmaId: string, dados: NovoParticipante, csrfToken: string): Promise<ParticipanteComCodigo> {
    return escrever(`${turma(turmaId)}/participantes`, 'POST', csrfToken, dados);
}

export function alterarParticipante(
    turmaId: string, participanteId: string, mudanca: AlteracaoParticipante, csrfToken: string,
): Promise<ParticipanteCadastrado> {
    return escrever(`${turma(turmaId)}/participantes/${encodeURIComponent(participanteId)}`, 'PATCH', csrfToken, mudanca);
}

export function trocarCodigo(turmaId: string, participanteId: string, csrfToken: string): Promise<ParticipanteComCodigo> {
    return escrever(`${turma(turmaId)}/participantes/${encodeURIComponent(participanteId)}/codigo`, 'POST', csrfToken);
}
